<template>
  <div class="layout">
    <div class="layout__header">
      <div class="layout__title">
        <h3>Registro de Médico</h3>
      </div>
    </div>
    <div class="card">
      <div class="card__content">
        <div class="row">
          <div class="col-xs-12 col-md-6">
            <div class="form-field">
              <input-field
                id="nombre"
                placeholder="Nombres y apellidos"
                v-model="form.nombre"
              >
                <span>Nombre*</span>
                <span
                  v-if="errores.nombre"
                  class="helper-text text-danger"
                  slot="helper"
                >
                  <strong>{{ errores.nombre[0] }}</strong>
                </span>
              </input-field>
            </div>
          </div>
          <div class="col-xs-12 col-md-6">
            <div class="form-field">
              <input-field
                type="password"
                id="clave_acceso"
                placeholder="Clave de acceso"
                v-model="form.clave_acceso"
              >
                <span>Contraseña*</span>
                <span
                  v-if="errores.clave_acceso"
                  class="helper-text text-danger"
                  slot="helper"
                >
                  <strong>{{ errores.clave_acceso[0] }}</strong>
                </span>
              </input-field>
            </div>
          </div>
          <div class="col-xs-12 col-md-6">
            <div class="form-field">
              <input-field
                type="password"
                id="clave_acceso_confirmation"
                placeholder="Confirmar clave..."
                v-model="form.clave_acceso_confirmation"
              >
                <span>Confirmación de contraseña*</span>
                <span
                  v-if="errores.clave_acceso_confirmation"
                  class="helper-text text-danger"
                  slot="helper"
                >
                  <strong>{{ errores.clave_acceso_confirmation[0] }}</strong>
                </span>
              </input-field>
            </div>
          </div>
          <div class="col-xs-12 col-md-6">
            <div class="form-field">
              <div class="datepicker-field">
                <date-picker
                  type="date"
                  id="fecha_nacimiento"
                  v-model="form.fecha_nacimiento"
                ></date-picker>
                <label>Fecha de nacimiento*</label>
                <span
                  v-if="errores.fecha_nacimiento"
                  class="helper-text text-danger"
                  slot="helper"
                >
                  <strong>{{ errores.fecha_nacimiento[0] }}</strong>
                </span>
              </div>
            </div>
          </div>
          <div class="col-xs-12 col-md-6">
            <div class="form-field">
              <input-field readonly id="edad" placeholder="Edad" :value="edad">
                <span>Edad</span>
              </input-field>
            </div>
          </div>
          <div class="col-xs-12 col-md-6">
            <div class="form-field select">
              <div class="select-field">
                <select
                  name="tipo_documento"
                  v-model="form.tipo_documento"
                  id="tipo_documento"
                >
                  <option value="C">Cédula</option>
                  <option value="R">RUC</option>
                  <option value="P">Pasaporte</option>
                </select>
                <label for="tipo_documento">Tipo de documento*</label>
              </div>
            </div>
          </div>
          <div class="col-xs-12 col-md-6">
            <div class="form-field">
              <input-field
                v-mask="'#############'"
                id="cedula"
                placeholder="Número de identificación"
                v-model="form.cedula"
              >
                <span>Céd/RUC/Pasaporte*</span>
                <span
                  v-if="errores.cedula"
                  class="helper-text text-danger"
                  slot="helper"
                >
                  <strong>{{ errores.cedula[0] }}</strong>
                </span>
              </input-field>
            </div>
          </div>
          <div class="col-xs-12 col-md-6">
            <div class="form-field select2">
              <div class="select2-field">
                <v-select
                  v-model="selectedProvincia"
                  @input="inputProvincia"
                  id="provincia"
                  placeholder="Seleccione..."
                  :options="provincias"
                  label="descripcion"
                ></v-select>
                <label for="provincia">Provincia*</label>
              </div>
            </div>
          </div>
          <div class="col-xs-12 col-md-6">
            <div class="form-field select2">
              <div class="select2-field">
                <v-select
                  v-model="selectedCiudad"
                  @input="inputCiudad"
                  id="ciudad"
                  placeholder="Seleccione..."
                  :options="ciudades"
                  label="descripcion"
                ></v-select>
                <label for="ciudad">Ciudad*</label>
                <span
                  v-if="errores.ciudad_id"
                  class="helper-text text-danger"
                  slot="helper"
                >
                  <strong>{{ errores.ciudad_id[0] }}</strong>
                </span>
              </div>
            </div>
          </div>
          <div class="col-xs-12 col-md-6">
            <div class="form-field">
              <input-field
                id="direccion"
                placeholder="Escriba una dirección..."
                v-model="form.direccion"
              >
                <span>Dirección de consultorio u otro*</span>
                <span
                  v-if="errores.direccion"
                  class="helper-text text-danger"
                  slot="helper"
                >
                  <strong>{{ errores.direccion[0] }}</strong>
                </span>
              </input-field>
            </div>
          </div>
          <div class="col-xs-12 col-md-6">
            <div class="form-field">
              <input-field
                id="telefonos"
                placeholder="Escriba uno o varios teléfonos..."
                v-model="form.telefonos"
              >
                <span>Teléfonos</span>
                <span
                  v-if="errores.telefonos"
                  class="helper-text text-danger"
                  slot="helper"
                >
                  <strong>{{ errores.telefonos[0] }}</strong>
                </span>
              </input-field>
            </div>
          </div>
          <!-- <div class="col-xs-12 col-md-6">
            <div class="form-field">
              <input-field
                id="codigo_senescyt"
                placeholder="Escriba el código..."
                v-model="form.codigo_senescyt"
              >
                <span>Código Senescyt*</span>
                <span
                  v-if="errores.codigo_senescyt"
                  class="helper-text text-danger"
                  slot="helper"
                >
                  <strong>{{ errores.codigo_senescyt[0] }}</strong>
                </span>
              </input-field>
            </div>
          </div> -->
          <div class="col-xs-12 col-md-6">
            <div class="form-field">
              <input-field
                id="correo"
                placeholder="Escriba una dirección de correo electrónico..."
                v-model="form.correo"
              >
                <span>Correo electrónico</span>
                <span
                  v-if="errores.correo"
                  class="helper-text text-danger"
                  slot="helper"
                >
                  <strong>{{ errores.correo[0] }}</strong>
                </span>
              </input-field>
            </div>
          </div>
          <div class="col-xs-12 col-md-6">
            <label for="masculino">
              <input
                type="radio"
                name="sexo"
                id="masculino"
                v-model="form.sexo"
                value="M"
              />
              <span>Masculino</span>
            </label>
            <label for="femenino">
              <input
                type="radio"
                name="sexo"
                id="femenino"
                v-model="form.sexo"
                value="F"
              />
              <span>Femenino</span>
            </label>
          </div>
          <div class="col-xs-12 col-md-6">
            <div class="form-field select2">
              <div class="select2-field">
                <v-select
                  placeholder="Seleccione..."
                  @input="inputEspecialidades"
                  id="especialidades"
                  :options="especialidades"
                  label="descripcion"
                  v-model="selectedEspecialidades"
                  multiple
                ></v-select>
                <label for="especialidades">Especialidades</label>
                <span
                  v-if="errores.especialidades"
                  class="helper-text text-danger"
                  slot="helper"
                >
                  <strong>{{ errores.especialidades[0] }}</strong>
                </span>
              </div>
            </div>
          </div>
          <div class="col-xs-12 col-md-6">
            <div class="form-field">
              <p>
                <label for="es_otras_especialidades">
                  <input v-model="form.es_otras_especialidades" type="checkbox" name="es_otras_especialidades" id="es_otras_especialidades"><span>Tiene otras especialidades</span>
                </label>
              </p>
            </div>
          </div>
          <div v-show="form.es_otras_especialidades" class="col-xs-12 col-md-6">
            <div class="form-field">
              <input-field id="otras_especialidades" v-model="form.otras_especialidades" placeholder="Especifique...">
                Otras especialidades
                <span
                  v-if="errores.otras_especialidades"
                  class="helper-text text-danger"
                  slot="helper"
                >
                  <strong>{{ errores.otras_especialidades[0] }}</strong>
                </span>
              </input-field>
            </div>
          </div>
          <div class="col-xs-12 col-md-6">
            <div class="form-field">
              <p>
                <label for="es_odontologo">
                  <input v-model="form.es_odontologo" type="checkbox" name="es_odontologo" id="es_odontologo"><span>Es odontólogo</span>
                </label>
              </p>
            </div>
          </div>
          <div class="col-xs-12 col-md-6">
            <div class="form-field select">
              <div class="select-field">
                <select name="tipo_cuenta" id="tipo_cuenta" v-model="form.tipo_cuenta">
                  <option value="A">Ahorros</option>
                  <option value="C">Corriente</option>
                </select>
                <label for="tipo_cuenta">Tipo de cuenta</label>
                <span
                  v-if="errores.tipo_cuenta"
                  class="helper-text text-danger"
                  slot="helper"
                >
                  <strong>{{ errores.tipo_cuenta[0] }}</strong>
                </span>
              </div>
            </div>
          </div>
          <div class="col-xs-12 col-md-6">
            <div class="form-field">
              <input-field v-mask="'####################'" id="numero_cuenta" v-model="form.numero_cuenta" placeholder="Especifique...">
                Número de cuenta
                <span
                  v-if="errores.numero_cuenta"
                  class="helper-text text-danger"
                  slot="helper"
                >
                  <strong>{{ errores.numero_cuenta[0] }}</strong>
                </span>
              </input-field>
            </div>
          </div>
          <div class="col-xs-12 col-md-6">
            <div class="form-field">
              <input-field id="nombre_cuenta" v-model="form.nombre_cuenta" placeholder="Especifique...">
                Nombre de propietario
                <span
                  v-if="errores.nombre_cuenta"
                  class="helper-text text-danger"
                  slot="helper"
                >
                  <strong>{{ errores.nombre_cuenta[0] }}</strong>
                </span>
              </input-field>
            </div>
          </div>
          <div class="col-xs-12 col-md-6">
            <div class="form-field select">
              <div class="select-field">
                <select
                  name="tipo_identificacion_cuenta"
                  v-model="form.tipo_identificacion_cuenta"
                  id="tipo_identificacion_cuenta"
                >
                  <option value="C">Cédula</option>
                  <option value="R">RUC</option>
                  <option value="P">Pasaporte</option>
                </select>
                <label for="tipo_identificacion_cuenta">Tipo de documento de propietario</label>
              </div>
            </div>
          </div>
          <div class="col-xs-12 col-md-6">
            <div class="form-field">
              <input-field v-mask="'####################'" id="identificacion_cuenta" v-model="form.identificacion_cuenta" placeholder="Especifique...">
                Identificación del propietario
                <span
                  v-if="errores.identificacion_cuenta"
                  class="helper-text text-danger"
                  slot="helper"
                >
                  <strong>{{ errores.identificacion_cuenta[0] }}</strong>
                </span>
              </input-field>
            </div>
          </div>
          <div class="col-xs-12 col-md-6">
            <div class="form-field">
              <input-field id="banco" v-model="form.banco" placeholder="Especifique...">
                Nombre del banco
                <span
                  v-if="errores.banco"
                  class="helper-text text-danger"
                  slot="helper"
                >
                  <strong>{{ errores.banco[0] }}</strong>
                </span>
              </input-field>
            </div>
          </div>
          <div class="col-xs-12 col-md-6">
            <div class="form-field">
              <textarea-field
                :max="500"
                id="comentario"
                placeholder="Escriba un comentario..."
                v-model="form.comentario"
              >
                <span>Comentario</span>
                <span v-if="errores.comentario" class="helper-text text-danger" slot="helper">
                  <strong>{{ errores.comentario[0] }}</strong>
                </span>
              </textarea-field>
            </div>
          </div>
          <div class="col-xs-12 col-md-6">
            <div class="form-field">
              <div class="file-upload-field">
                <label>Foto de perfil (lo más nítida posible)</label>
                <file-upload
                  :defaultImage="srcImagen"
                  ref="fileUpload"
                ></file-upload>
                <button
                  @click="descargarImagen(srcImagen)"
                  class="btn-info btn--text"
                  type="button"
                >
                  <i class="fa fa-download"></i>
                </button>
                <button
                  type="button"
                  @click="quitarFoto"
                  class="btn-danger btn--text"
                >
                  <i class="fa fa-times"></i>
                </button>
              </div>
              <span
                v-if="errores.imagen"
                class="helper-text text-danger"
                slot="helper"
              >
                <strong>{{ errores.imagen[0] }}</strong>
              </span>
            </div>
          </div>
          <div class="col-xs-12 col-md-6">
            <div class="form-field">
              <div class="file-upload-field">
                <label>Logo profesional</label>
                <file-upload
                  id="receta"
                  :defaultImage="srcReceta"
                  ref="fileImagenReceta"
                ></file-upload>
                <button
                  @click="descargarImagen(srcReceta)"
                  class="btn-info btn--text"
                  type="button"
                >
                  <i class="fa fa-download"></i>
                </button>
                <button
                  type="button"
                  @click="quitarLogo"
                  class="btn-danger btn--text"
                >
                  <i class="fa fa-times"></i>
                </button>
              </div>
              <span
                v-if="errores.logo_receta"
                class="helper-text text-danger"
                slot="helper"
              >
                <strong>{{ errores.logo_receta[0] }}</strong>
              </span>
            </div>
          </div>
          <div class="col-xs-12 col-md-6" v-show="false">
            <div class="form-field">
              <div class="file-upload-field">
                <label>Sello profesional</label>
                <file-upload
                  id="sello"
                  :defaultImage="srcSello"
                  ref="fileImagenSello"
                ></file-upload>
                <button
                  @click="descargarImagen(srcSello)"
                  class="btn-info btn--text"
                  type="button"
                >
                  <i class="fa fa-download"></i>
                </button>
                <button
                  type="button"
                  @click="quitarSello"
                  class="btn-danger btn--text"
                >
                  <i class="fa fa-times"></i>
                </button>
              </div>
              <span
                v-if="errores.foto_sello"
                class="helper-text text-danger"
                slot="helper"
              >
                <strong>{{ errores.foto_sello[0] }}</strong>
              </span>
            </div>
          </div>
          <div class="col-xs-12 col-md-6" v-show="false">
            <div class="form-field">
              <div class="file-upload-field">
                <label>Firma digital (foto nítida de su firma)</label>
                <file-upload
                  id="firma"
                  :defaultImage="srcFirma"
                  ref="fileImagenFirma"
                ></file-upload>
                <button @click="verInformacionFirma" type="button" class="btn-warning btn--text"><i class="fa fa-question"></i></button>
                <button
                  @click="descargarImagen(srcFirma)"
                  class="btn-info btn--text"
                  type="button"
                >
                  <i class="fa fa-download"></i>
                </button>
                <button
                  type="button"
                  @click="quitarFirma"
                  class="btn-danger btn--text"
                >
                  <i class="fa fa-times"></i>
                </button>
              </div>
              <span
                v-if="errores.foto_firma"
                class="helper-text text-danger"
                slot="helper"
              >
                <strong>{{ errores.foto_firma[0] }}</strong>
              </span>
            </div>
          </div>
          <div class="col-xs-12 col-md-6">
            <div class="form-field">
              <div class="file-upload-field">
                <label>Firma electrónica</label>
                <file-upload
                  id="firmaElectronica"
                  ref="fileUploadFirmaElectronica"
                  :defaultImage="srcFirmaElectronica"
                  soloFirmaElectronica
                ></file-upload>
                <button
                  type="button"
                  @click="quitarFirmaElectronica"
                  class="btn-danger btn--text"
                >
                  <i class="fa fa-times"></i>
                </button>
              </div>
            </div>
          </div>
          <div class="col-xs-12 col-md-6">
            <div class="form-field">
              <div class="datepicker-field">
                <date-picker
                  type="date"
                  id="fecha_caducidad_firma_electronica"
                  v-model="form.fecha_caducidad_firma_electronica"
                ></date-picker>
                <label>Fecha caduc. (Firma Elect.)</label>
                <span v-if="errores.fecha_caducidad_firma_electronica" class="helper-text text-danger" slot="helper">
                  <strong>{{ errores.fecha_caducidad_firma_electronica[0] }}</strong>
                </span>
              </div>
            </div>
          </div>
          <div class="col-xs-12 col-md-6">
            <div class="form-group">
              <input-field
                :type="!viendoPassword?'password':'text'"
                v-model="form.password_firma_electronica"
                id="password_firma_electronica"
                placeholder="Ingrese la contraseña..."              
              >
                <span>Contraseña firma electr.</span>
                <span
                  v-if="errores.password_firma_electronica"
                  class="helper-text text-danger"
                  slot="helper"
                  >{{ errores.password_firma_electronica[0] }}</span
                >
              </input-field>
              <button type="button" @click="verPassword" class="btn-info btn--text"><i :class="{
                'fa-eye': !viendoPassword,
                'fa-eye-slash': viendoPassword
              }" class="fa"></i></button>
            </div>
          </div>
          <div class="col-xs-12 col-md-6">
            <div class="form-field">
              <input-field
                type="password"
                v-model="form.password_firma_electronica_confirmation"
                id="password_firma_electronica_confirmation"
                placeholder="Confirme la contraseña..."            
              >
                <span>Confirm. de cont. de firma elect.</span>
              </input-field>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-xs-12">
            <div class="form-inline">
              <button @click="guardar" class="btn-success" type="button">
                <i class="fa fa-save"></i>
                <span>Registrarme</span>
              </button>
              <button
                @click="cancelar"
                class="btn-danger btn--text"
                type="button"
              >
                <i class="fa fa-ban"></i>
                <span>Cancelar</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    especialidades: {
      type: Array,
      required: false,
      default: function () {
        return [];
      },
    },
    maximo_especialidades: {
      type: Number,
      required: false,
      default: 3,
    },
    provincias: {
      type: Array,
      required: false,
      default: function () {
        return [];
      },
    },
    limiteEdad: {
      type: Number,
      required: false,
      default: 18,
    },
  },
  computed: {
    edad: function () {
      if (
        this.form.fecha_nacimiento != null &&
        this.form.fecha_nacimiento.length === 10
      ) {
        let date = new Date(this.form.fecha_nacimiento);
        if (date != "Invalid Date")
          return moment(new Date()).diff(date, "years");
      }
      return "";
    },
  },
  data: function () {
    return {
      money: money,
      viendoPassword: false,
      selectedCiudad: null,
      selectedProvincia: null,
      srcFirmaElectronica: "",
      form: {
        es_odontologo: false,
        tipo_identificacion_cuenta: 'C',
        comentario: '',
        codigo_senescyt: '',
        imagen: "",
        nombre: "",
        fecha_nacimiento: "",
        cedula: "",
        direccion: "",
        telefonos: "",
        correo: "",
        sexo: "M",
        especialidades: [],
        clave_acceso: "",
        ciudad_id: "",
        provincia_id: "",
        logo_receta: "",
        foto_sello: "",
        foto_firma: "",
        path_firma_electronica: "",
        fecha_caducidad_firma_electronica: "",
        password_firma_electronica: "",
        password_firma_electronica_confirmation: "",
        tipo_documento: "C",
        tipo_cuenta: 'A',
        numero_cuenta: '',
        nombre_cuenta: '',
        identificacion_cuenta: '',
        banco: ''
      },
      errores: {},
      selectedEspecialidades: [],
      srcImagen: "",
      srcReceta: "",
      srcSello: "",
      srcFirma: "",
      ciudades: [],
      decimal5: decimal5,
    };
  },
  methods: {
    verPassword: function() {
      this.viendoPassword = !this.viendoPassword;
    },
    quitarFirmaElectronica: function() {
      this.form.path_firma_electronica = "N/I";
      this.$refs.fileUploadFirmaElectronica.resetImagen();
    },
    verInformacionFirma: function () {
      swal({
        imageUrl: 'https://upload.wikimedia.org/wikipedia/commons/4/4e/Firma_digital_Jonnatan_Molina_Yanez.png',
        imageHeight: 250,
        imageAlt: 'Información de firma'
      });
    },
    cancelar: function () {
      location.href = url;
    },
    quitarFirma: function () {
      this.form.foto_firma = "N/I";
      this.$refs.fileImagenFirma.resetImagen();
    },
    quitarSello: function () {
      this.form.foto_sello = "N/I";
      this.$refs.fileImagenSello.resetImagen();
    },
    quitarLogo: function () {
      this.form.logo_receta = "N/I";
      this.$refs.fileImagenReceta.resetImagen();
    },
    quitarFoto: function () {
      this.form.imagen = "N/I";
      this.$refs.fileUpload.resetImagen();
    },
    descargarImagen: function (img) {
      if (img != null && img !== "") {
        let link = document.createElement("a");
        let filename = img.substring(img.lastIndexOf("/") + 1);
        link.download = filename;
        link.href = img;
        link.click();
      } else swal("No hay archivo para descargar.", "Aviso", "warning");
    },
    cargarCiudades: function () {
      let that = this;
      axios
        .get(url + "/ciudades/" + this.selectedProvincia.id_provincia)
        .then(function (response) {
          that.ciudades = response.data;
          for (let i = 0; i < that.ciudades.length; i++)
            if (that.ciudades[i].id_ciudad == that.form.ciudad_id) {
              that.selectedCiudad = that.ciudades[i];
              break;
            }
        });
    },
    inputProvincia: function () {
      this.selectedCiudad = null;
      if (this.selectedProvincia !== null) {
        this.form.provincia_id = this.selectedProvincia.id_provincia;
        this.cargarCiudades();
      } else this.form.provincia_id = "";
    },
    inputCiudad: function () {
      if (this.selectedCiudad !== null)
        this.form.ciudad_id = this.selectedCiudad.id_ciudad;
      else this.form.ciudad_id = "";
    },
    cargarImagen: function () {
      if (this.form.imagen !== "N/I")
        this.form.imagen = this.$refs.fileUpload.recuperarImagen();
    },
    cargarImagenSello: function () {
      if (this.form.foto_sello !== "N/I")
        this.form.foto_sello = this.$refs.fileImagenSello.recuperarImagen();
    },
    cargarImagenFirma: function () {
      if (this.form.foto_firma !== "N/I")
        this.form.foto_firma = this.$refs.fileImagenFirma.recuperarImagen();
    },
    cargarImagenReceta: function () {
      if (this.form.logo_receta !== "N/I")
        this.form.logo_receta = this.$refs.fileImagenReceta.recuperarImagen();
    },
    inputEspecialidades: function () {
      this.form.especialidades.splice(0, this.form.especialidades.length);
      for (let i = 0; i < this.selectedEspecialidades.length; i++) {
        this.form.especialidades.push(this.selectedEspecialidades[i].id);
      }
    },
    cargarFirmaElectronica: function() {
      if (this.form.path_firma_electronica !== "N/I")
        this.form.path_firma_electronica = this.$refs.fileUploadFirmaElectronica.recuperarImagen();
    },
    guardar: function () {
      if (this.form.password_firma_electronica != this.form.password_firma_electronica_confirmation) {
        swal(
          "La contraseña de la firma electrónica no coincide con la confirmación",
          "Aviso",
          "warning"
        );
        return;
      }      
      swal({
        title: "¿Desea registrarse?",
        text: "Se requiere de confirmación",
        type: "question",
        showCancelButton: true,
        confirmButtonText: "Registrar",
        cancelButtonText: "No",
      }).then((result) => {
        if (result.value) {
          if (this.edad !== "" && this.edad < this.limiteEdad) {
            swal(
              "La edad mínima es: " + this.limiteEdad + ".",
              "Aviso",
              "warning"
            );
            return;
          }
          if (this.selectedEspecialidades.length > this.maximo_especialidades) {
            swal(
              "Se puede asignar hasta 3 especialidades.",
              "Aviso",
              "warning"
            );
            return;
          }
          let that = this;
          let urlRequest = url + "/registro";
          this.cargarImagen();
          this.cargarImagenSello();
          this.cargarImagenFirma();
          this.cargarImagenReceta();
          this.cargarFirmaElectronica();
          if (this.form.path_firma_electronica == "N/I")
            this.form.path_firma_electronica = '';
          axios
            .post(urlRequest, this.form)
            .then(function (response) {
              swal(
                "Has sido registrado exitósamente, se efectuará la aprobación de la cuenta.",
                "Realizado",
                "success"
              );
              location.reload(true);
            })
            .catch(function (error) {
              if (error && error.response) {
                let response = error.response;
                let status = response.status;
                switch (status) {
                  case 422:
                    that.errores = response.data.errors;
                    swal("Hay errores en el formulario.", "Aviso", "warning");
                    return;
                }
              }
              swal("Hubo un error, intente nuevamente.", "Error", "error");
            });
        }
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/forms/doctores/RegistroDoctor.vue